<template>
<div class="chapter">
<div class="inner_page">
<p class="ded"><a id="page_v"><span class="txit">For Navah Not just contractually—with all my heart.</span></a><a id="page_vi"></a></p><a id="page_vi">
</a>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// dedication.vue?770aa160